import * as React from "react";
import { connect } from "react-redux";
import Header from "./Header";
import { MultipleChoiceForm } from "./MultipleChoiceForm";
import { Choice } from "../../models/choice";
import { FormStep, Step } from "../../store/application/applicationState";
import { ApplicationAction, setMarried, gotoStep } from "../../store/application/applicationActions";
import ApplicationContent from "../applicationContent";
import { trackEvent } from "../../util/gtm";
import { SharedExpenses } from "../../lib-api/models/SharedExpenses";
import ApplicationFooter from "../applicationFooter";
import { Row, Col, Button, FormGroup, CustomInput, Label } from "reactstrap";
import { RootState } from "../../store";
import CurrencyInput from "./CurrencyInput";
import { maritalExpensesAttribute } from "../../models/maritalExpensesAttribute";

type Props = ReturnType<typeof mapDispatchToProps>;


interface State {
    dirty: boolean;
    maritalExpenses: string;
    sharedExpenses: SharedExpenses;
    show: boolean;
    marital:string;

}

class Marital extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            dirty: false,
            maritalExpenses: "",
            sharedExpenses: SharedExpenses.Nej ,
            show: false,
            marital:""
        }
    }
    hasPartner(val): void {
        this.setState({
            show: true,
            marital: val
        })
    };
reset():void{
   this.setState({
            show: false,
            marital:""
        })
}
    next(): void {
        this.setState({ dirty: true });
        console.log(this.state.maritalExpenses);
        console.log(this.state.sharedExpenses);
        const test = !maritalExpensesAttribute.hasError(this.state.maritalExpenses);
        console.log(this.state.show);
        if (test == true || this.state.sharedExpenses == SharedExpenses.Nej) {
            this.props.setIsMarried(this.state.marital, this.state.sharedExpenses, this.state.maritalExpenses);
            trackEvent(
                "Civilstatus",
                "Er " + this.state.marital,
                "Brugeren's civilstatus",
                "Er " + this.state.marital
            )
        }


}

    private choices: Array<Choice<string>> = [
        new Choice<string>("Gift", "Gift", val => { this.hasPartner(val) }),
        new Choice<string>("Ugift", "Ugift", val => { this.props.setIsMarried(val, SharedExpenses.Nej, "") }),
        new Choice<string>("Samlevende", "Samlevende", val => { this.hasPartner(val) }),
        new Choice<string>("Alene", "Alene", val => { this.props.setIsMarried(val, SharedExpenses.Nej, "") }),
        new Choice<string>("Skilt/separeret", "Skilt/separeret", val => { this.props.setIsMarried(val, SharedExpenses.Nej, "") }),
        new Choice<string>("Enke/enkemand", "Enke/enkemand", val => { this.props.setIsMarried(val, SharedExpenses.Nej, "") })
    ]




    render() {
        var params = window.location.search.toString();
        var regex = /((&|\?)step=)[0-9]{1,2}/gi;
        if (params != "") {
            params = params.replace(regex, "$1" + "6");
        }
        var stepQuery = window.location.protocol + "//" + window.location.host + window.location.pathname + params;
        window.history.pushState({ path: stepQuery }, '', stepQuery)
        return (
            <div>
                <Header formStep={FormStep.Other} step={Step.Marital}  />
                <ApplicationContent>
                    {!this.state.show && <MultipleChoiceForm
                        title="Civilstatus"
                        paragraph="Hvad er din nuværende civilstatus?"
                        choices={this.choices}
                        collumns={3}
                    />}
                    {this.state.show &&
                        <FormGroup>
                            <div>
                            <p>Deles husstandens omkostninger med din samlever?</p>


                            <CustomInput
                                invalid={this.state.dirty && !this.state.sharedExpenses}
                                type="radio"
                                id="sharedExpensesYes"
                                name="sharedExpenses"
                                label="Ja"
                                checked={this.state.sharedExpenses == SharedExpenses.Ja}
                                onChange={e =>
                                    e.target.checked &&
                                    this.setState({ sharedExpenses: SharedExpenses.Ja })
                                }
                            />
                         
                            
                            <CustomInput
                                invalid={this.state.dirty && !this.state.sharedExpenses}
                                type="radio"
                                id="sharedExpensesNo"
                                name="sharedExpenses"
                                label="Nej"
                                checked={this.state.sharedExpenses == SharedExpenses.Nej}
                                onChange={e =>
                                    e.target.checked &&
                                    this.setState({ sharedExpenses: SharedExpenses.Nej })
                                }
                            />
                            {this.state.sharedExpenses == SharedExpenses.Ja &&
                                <FormGroup>
                                <br/>
                                        <p>
                                            Hvad får samlever udbetalt pr. måned?
    
                                            Jeg bekræfter at oplysningen gives med min samlevers samtykke.
                                        </p>
                                <Label for="maritalExpenses" className="text-uppercase font-weight-bold">
                                            Skriv beløb
                                      </Label>
                                <CurrencyInput
                                    maskOptions
                                    className={
                                        this.state.dirty && maritalExpensesAttribute.hasError(this.state.maritalExpenses)
                                            ? "is-invalid cpr form-control"
                                            : "cpr form-control"
                                    }
                                    type="text"
                                    id="maritalExpenses"
                                    name="maritalExpenses"
                                    placeholder="Indtast beløb"
                                    value={this.state.maritalExpenses}

                                    onChange={event => this.setState({ maritalExpenses: event.target.value }) }
                                    />
                                {this.state.dirty && maritalExpensesAttribute.hasError(this.state.maritalExpenses) && (
                                            <div className="invalid-feedback">
                                        {maritalExpensesAttribute.getErrorMessage()}
                                            </div>
                                        )}
                                    </FormGroup>
                                }


                            </div>
                 
                        </FormGroup>
                    
                    }
                </ApplicationContent>
                <ApplicationFooter>
                    <Row className="mt-2">
                        <Col className="col-12 text-right">
                           {!this.state.show &&
                           <Button className="back" onClick={() => this.props.previous()}>
                                Tilbage
                           </Button>}

                            {this.state.show &&
                           <Button className="back" onClick={() => this.reset()}>
                                Tilbage
                           </Button>}
                            {this.state.show &&
                                <Button className="next" onClick={() => {
                                    this.next();

                                }}>
                                    Næste
                        </Button>}
                          
                        </Col>
                    </Row>

                </ApplicationFooter>
            </div>
        );
    }
}


const mapStateToProps = (state: RootState) => ({
    application: state.applicationState
});

const mapDispatchToProps = (dispatch: (action: ApplicationAction) => void) => ({
    previous: () => dispatch(gotoStep(Step.LoanReason)),
    setIsMarried: (isMarried: string, sharedExpenses: SharedExpenses, maritalExpenses: string) => {
        dispatch(setMarried(isMarried, sharedExpenses, maritalExpenses));
    
    }
});

export default connect(
    null,
    mapDispatchToProps
)(Marital);